<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>订单管理</el-breadcrumb-item>
      <el-breadcrumb-item>低温订单列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-tabs v-model="tabIndex" @tab-click="handleClick">
      <el-tab-pane v-for="item in statusOptions" :key="item.id" :label="item.value"></el-tab-pane>
    </el-tabs>

    <!-- 卡片视图区域 -->
    <el-card>
      <el-row>
        <el-col :span="5">
          <el-input placeholder="请输入订单号" v-model="queryInfo.query" clearable @clear="getOrderList">
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
        </el-col>
        <el-col :span="5">
          <el-input placeholder="请输入经销商名称" v-model="queryInfo.agencyName" clearable @clear="getOrderList">
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
        </el-col>
        <el-col :span="8">
          <div class="block aaaa">
            <el-date-picker
              v-model="queryInfo.time"
              @change="timechange"
              type="daterange"
              :default-time="['00:00:00', '23:59:59']"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </div>
        </el-col>

        <el-col :span="4" v-if="canLook == 1 && tabIndex != 5">
          <a class="aaaa" :href="exportUrl + '&time=' + JSON.stringify(queryInfo.time) + '&status=' + queryInfo.status + '&order_id=' + queryInfo.query + '&agencyName=' + queryInfo.agencyName">
            <el-button size="mini" type="info">导出订单</el-button>
          </a>
        </el-col>
      </el-row>

      <!-- 订单列表数据 -->
      <el-table id="out-table" :data="orderlist" border stripe ref="multipleTable" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" fixed :key="Math.random()"> </el-table-column>
        <el-table-column type="index" :key="Math.random()"></el-table-column>

        <el-table-column label="商品信息" type="expand" :key="Math.random()">
          <template slot-scope="scope">
            <el-table :data="scope.row.goods_info" border stripe ref="xxxTable" tooltip-effect="dark">
              <el-table-column label="商品名称" prop="goodinfo.title" width="180px"> </el-table-column>
              <el-table-column label="商品编号" prop="goodinfo.number" width="70px"> </el-table-column>
              <el-table-column label="商品规格" prop="goodinfo.preNum" width="70px"> </el-table-column>
              <el-table-column label="商品单价" prop="goodinfo.price" align="center" width="70px"> </el-table-column>
              <el-table-column label="购买数量" prop="goodinfo.buyNum" width="70px"> </el-table-column>
              <el-table-column label="赠送件数" prop="goodinfo.sendNumber" width="70px"> </el-table-column>
              <el-table-column label="小计" prop="goodinfo.goodTotalNum" width="70px"> </el-table-column>
              <el-table-column label="预定下周订单截止时间" prop="goodinfo.g_endTime" align="center" width="150px"> </el-table-column>
              <el-table-column label="是否已确定商品" prop="goodinfo.statusTxt" align="center" width="120px"> </el-table-column>
              <el-table-column label="参与活动" prop="goodinfo.activityContent" align="center" width="120px"> </el-table-column>
              <el-table-column label="下周/下下周" prop="goodinfo.week" align="center" width="130px"> </el-table-column>
            </el-table>
          </template>
        </el-table-column>

        <el-table-column label="订单编号" prop="order_id" width="150px" :key="Math.random()"></el-table-column>
        <el-table-column label="下单经销商" prop="agencyName" width="130px" :key="Math.random()"></el-table-column>
        <el-table-column label="总价格" prop="order_amount_total" align="center" width="60px" :key="Math.random()"> </el-table-column>
        <el-table-column label="总数量" prop="totalNum" align="center" width="60px" :key="Math.random()"> </el-table-column>
        <el-table-column label="区域" v-if="tabIndex == 3 || tabIndex == 2 || tabIndex == 4" prop="buType" align="center" width="60px" :key="Math.random()"> </el-table-column>
        <el-table-column label="状态" prop="order_status" width="140px" :key="Math.random()">
          <!-- 全部-1 待支付0 待确认1 ,待发货2,已发货3 ,已完成4, 退款5 取消6 -->
          <template slot-scope="scope">
            <el-tag type="warning" v-if="scope.row.order_status == '0'">未付款</el-tag>
            <el-tag class="daiqueren" v-if="scope.row.order_status == '1'">待确认</el-tag>
            <el-tag class="daifahuo" v-if="scope.row.order_status == '2'">待发货</el-tag>
            <el-tag class="yifahuo" v-if="scope.row.order_status == '3'">已发货</el-tag>
            <el-tag type="success" v-if="scope.row.order_status == '4'">已完成</el-tag>
            <el-tag type="danger" v-if="scope.row.order_status == '5' && scope.row.tuikuanStatus == '0'">退款中，待确认</el-tag>
            <el-tag type="danger" v-if="scope.row.order_status == '5' && scope.row.tuikuanStatus == '1'">退款成功</el-tag>
            <el-tag type="info" v-if="scope.row.order_status == '6'">已取消</el-tag>
          </template>
        </el-table-column>

        <el-table-column label="下单时间" prop="create_at" width="130px" :key="Math.random()"></el-table-column>
        <el-table-column  label="取消时间" prop="create_at" width="130px" :key="Math.random()" >
          <template slot-scope="scope">
            <div v-if="scope.row.order_status == '6'">{{scope.row.cancel_at}}</div>
            <div v-if="scope.row.order_status != '6'">无</div>
          </template>
        </el-table-column>
        <el-table-column label="收货地址" prop="addressDetail" align="center" width="420px"  :key="Math.random()"></el-table-column>
        <el-table-column label="是否打印" v-if="tabIndex == 3" prop="printed" align="center" width="60px" :key="Math.random()"> </el-table-column>
        <el-table-column label="取消原因" v-if="tabIndex == 5" prop="cancel_reason" align="center" width="100px" :key="Math.random()"> </el-table-column>

        <el-table-column label="操作" width="360px" v-if="canLook == 1" :key="Math.random()">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" v-if="scope.row.order_status == 1" @click="clickSureOrder(scope.row.order_id)">确认</el-button>
            <el-button size="mini" type="primary" v-if="tabIndex < 5" @click="editOrder(scope.row.order_id)">编辑</el-button>
            <el-button size="mini" type="danger" v-if="scope.row.order_status == 1" @click="cancelOrder(scope.row.order_id)">删除</el-button>
            <a class="aaaa" target="_blank" v-if="scope.row.order_status == 3 || scope.row.order_status == 4" href="https://hsadmin.hsxsn.cn/print.html">
              <el-button size="mini" @click="exportOrder(scope.row.order_id)" type="info">预览</el-button>
            </a>
            <el-button size="mini" type="primary" v-if="scope.row.order_status == 3" @click="completeOneOrder(scope.row.order_id)">完成</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-row v-if="canLook == 1">
        <!-- <el-button type="primary" plain @click="sureOrder">批量订单确认</el-button> -->
        <!-- <el-button type="info" plain @click="sendOrder">批量订单发货</el-button> -->
        <el-button type="success" v-if="tabIndex == 3" plain @click="completeOrder">批量完成订单</el-button>
        <!-- <el-button type="danger" v-if="tabIndex == 1" plain @click="cancelOrder">批量取消订单</el-button> -->
      </el-row>
      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 20, 30]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>

    <!--发货对话框 -->
    <el-dialog title="发货信息" :visible.sync="sendVisible" width="50%" @close="sendDialogClosed">
      <el-form :model="sendForm" :rules="sendFormRules" ref="sendFormRef" label-width="100px">
        <el-form-item label="司机姓名" prop="sendName">
          <el-input v-model="sendForm.sendName"></el-input>
        </el-form-item>
        <el-form-item label="司机电话" prop="sendPhone">
          <el-input v-model="sendForm.sendPhone"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="sendVisible = false">取 消</el-button>
        <el-button type="primary" @click="sendVisibleSure">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 确认订单 -->
    <el-dialog title="确认订单" :visible.sync="sureOrderDialogVisible" width="50%" @close="sureOrderDialogClosed">
      <el-form :model="buTypeForm" label-width="130px">
        <el-form-item label="地区">
          <!-- <el-switch v-model="buTypeForm.buType" active-text="埠外" inactive-text="埠内"> </el-switch> -->
          <el-radio v-model="radio" label="1">埠内</el-radio>
          <el-radio v-model="radio" label="2">埠外</el-radio>
          <el-radio v-model="radio" label="3">省外</el-radio>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="sureOrderDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="sureOrder">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 订单取消的对话框 -->
    <el-dialog title="删除订单" :visible.sync="cancelVisible" width="50%" @close="cancelDialogClosed">
      <el-form :model="cancelForm" :rules="cancelFormRule" ref="cancelFormRef" label-width="100px">
        <el-form-item label="删除原因" prop="cancelSeasion">
          <el-input v-model="cancelForm.cancelSeasion"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelVisible = false">取消操作</el-button>
        <el-button type="primary" @click="cancelOrderClick">确定删除</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="de" width="80%" >
      <Detail ref="detail"  :valueId="order_id"/>
    </el-dialog>
  </div>
</template>
<script>
import Detail from "./DwDetail"
export default {
  components: {
    Detail
  },
  data () {
    return {
      de:false,
      order_id:'',
      radio: 0,
      canLook: 1,
      time: null,
      exportUrl: 'https://hsapi.hsxsn.cn//ydexportExcel?mPhone=' + localStorage.getItem('phone'),
      queryInfo: {
        query: '',
        agencyName: '',
        status: -1,
        type: 0,
        pagenum: 1,
        pagesize: 10,
        time: null
      },
      statusValue: '全部',
      statusOptions: [
        { value: '全部', id: -1 },
        // { value: '未付款', id: 0 },
        { value: '待确认', id: 1 },
        { value: '待发货', id: 2 },
        { value: '已发货', id: 3 },
        { value: '已完成', id: 4 },
        // { value: '退款', id: 5 },
        { value: '已取消', id: 6 },
      ],
      typeValue: '全部',
      typeOptions: [
        { value: '全部', id: 0 },
        { value: '下周订单', id: 1 },
        { value: '下下周订单', id: 2 },
      ],
      total: 0,
      orderlist: [],
      addressVisible: false,
      addressForm: {
        address1: [],
        address2: ''
      },
      addressFormRules: {
        address1: [
          { required: true, message: '请选择省市区县', trigger: 'blur' }
        ],
        address2: [
          { required: true, message: '请填写详细地址', trigger: 'blur' }
        ]
      },
      progressVisible: false,
      progressInfo: [],
      multipleSelection: [],
      multipleSelectionjson: null,
      sendVisible: false,
      sendForm: {
        sendName: null,
        sendPhone: null
      },
      cancelForm: {
        cancelSeasion: null,
      },

      cancelVisible: false,
      cancelFormRule: {
        cancelSeasion: [
          { required: true, message: '取消理由不能为空', trigger: 'blur' }
        ],
      },
      sendOrderId: 0,
      sendFormRules: {
        sendName: [
          { required: true, message: '请输入司机名字', trigger: 'blur' }
        ],
        sendPhone: [
          { required: true, message: '请输入司机号码', trigger: 'blur' }
        ]
      },
      selectOrderId: null,
      sureOrderDialogVisible: false,
      buTypeForm: {
        buType: true
      },
      tabIndex: 0
    }
  },

  created () {
    this.getOrderList()
  },

  methods: {

    cancelDialogClosed () {
      this.cancelVisible = false
    },

    cancelOrder (id) {
      this.selectOrderId = id;
      this.cancelVisible = true
    },

    // 取消订单
    async cancelOrderClick () {
      this.$refs.cancelFormRef.validate(async valid => {
        if (!valid) return
        const { data: res } = await this.$http.post('admin/order/cancelOrderInfo',
          {
            order_id: this.selectOrderId,
            cancelSeasion: this.cancelForm.cancelSeasion,
          })
        if (res.code !== 200) {
          return this.$message.error('操作失败！')
        }
        this.cancelVisible = false
        this.cancelForm.cancelSeasion = null
        this.getOrderList()
      })
    },
    handleClick (tab, event) {
      console.log(tab.index);
      this.tabIndex = tab.index;
      this.queryInfo.status = this.tabIndex == 5 ? 6 : this.tabIndex
      this.filterSelect();
    },
    //点击确认定点杆
    clickSureOrder (id) {
      this.selectOrderId = id;
      this.sureOrderDialogVisible = true;
    },

    sureOrderDialogClosed () {
      this.radio = 0
      // this.$refs.sendFormRef.resetFields()
    },

    timechange (e) {
      this.filterSelect();
    },

    sendOrder (id) {
      this.sendOrderId = id
      this.sendVisible = true
    },

    sendDialogClosed () {
      this.$refs.sendFormRef.resetFields()
    },

    // 发货订单
    async sendVisibleSure () {
      this.$refs.sendFormRef.validate(async valid => {
        if (!valid) return

        const { data: res } = await this.$http.post('admin/order/sendOrdersById', {
          order_id: this.sendOrderId,
          sendName: this.sendForm.sendName,
          sendPhone: this.sendForm.sendPhone,
        })
        if (res.code !== 200) {
          return this.$message.error(res.message)
        }
        this.sendVisible = false
        this.$message.success('订单发货成功！')
        this.getOrderList()
      })
    },

    // 编辑
    editOrder (id) {
      this.order_id = id,
      this.de = true
      // console.log(id);
      // this.$router.push({ path: '/orders/dwdetail', query: { id: id ,show:this.canLook} })
    },

    // 删除
    async deleteOrder (id) {
      const confirmResult = await this.$confirm(
        '订单删除后将不可找回,是否继续?',
        '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }
      ).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('取消操作！')
      }
      const { data: res } = await this.$http.post('admin/order/delete', {
        id: id,
      })
      if (res.code !== 200) {
        return this.$message.error('删除订单失败！')
      }
      this.$message.success('删除订单成功！')
      this.getOrderList()
    },

    // 完成单个订单
    async completeOneOrder (id) {
      const confirmResult = await this.$confirm(
        '将订单置为已完成状态, 是否继续?',
        '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }
      ).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('取消操作！')
      }
      const { data: res } = await this.$http.post('admin/order/completeOrder', {
        order_id: id,
      })
      if (res.code !== 200) {
        return this.$message.error('订单已完成操作失败！')
      }
      this.$message.success('订单已完成操作成功！')
      this.getOrderList()
    },


    filterSelect () {
      this.total = 0
      this.queryInfo.pagenum = 1
      this.orderlist = []
      this.getOrderList()
    },

    //搜索
    search () {
      this.total = 0
      this.queryInfo.pagenum = 1
      this.orderlist = []
      this.getOrderList()
    },

    // 多选选择的项
    handleSelectionChange (val) {
      this.multipleSelection = val;
      var list = [];
      val.forEach(element => {
        list.push({ 'id': element.id });
      });
      if (list.length > 0) {
        this.multipleSelectionjson = JSON.stringify(list);
        this.exportUrl = 'https://hsapi.hsxsn.cn//ydexportExcel?data=' + this.multipleSelectionjson + '&mPhone=' + localStorage.getItem('phone')
      } else {
        this.multipleSelectionjson = null;
        this.exportUrl = 'https://hsapi.hsxsn.cn//ydexportExcel?mPhone=' + localStorage.getItem('phone')
      }
    },

    // 确认订单 确认1 ,发货2,已完成3, 取消6
    async sureOrder () {

      console.log(this.radio);
      // return;
      if (this.radio == 0) {
        return this.$message.error('请选择地区！')
      }
      const { data: res } = await this.$http.post('admin/order/sureOrdersStatus', {
        id: this.selectOrderId,
        buType: this.radio
      })
      this.radio = 0
      if (res.code !== 200) {
        return this.$message.error('确认订单失败！')
      }

      this.$message.success('确认订单成功！')
      this.getOrderList()
      this.sureOrderDialogVisible = false;
    },

    // 批量确认订单 确认1 ,发货2,已完成3, 取消6
    async sureOrder1 () {
      if (this.multipleSelection == null || this.multipleSelection.length == 0) {
        return this.$message.info('请先勾选订单！')
      }
      const confirmResult = await this.$confirm(
        '将确认所有已选中的待确认订单，其余订单确认无效, 是否继续?',
        '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }
      ).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('取消操作！')
      }
      const { data: res } = await this.$http.post('admin/order/changeOrdersStatus', {
        data: this.multipleSelection,
        type: 1,
      })
      if (res.code !== 200) {
        return this.$message.error('确认订单失败！')
      }
      this.$message.success('确认订单成功！')
      this.getOrderList()
    },

    // 批量发货订单
    async sendOrder1 () {
      if (this.multipleSelection == null || this.multipleSelection.length == 0) {
        return this.$message.info('请先勾选订单！')
      }
      const confirmResult = await this.$confirm(
        '将发货所有已选中的已确认订单，其余订单发货无效, 是否继续?',
        '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }
      ).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('取消操作！')
      }
      const { data: res } = await this.$http.post('admin/order/changeOrdersStatus', {
        data: this.multipleSelection,
        type: 2,
      })
      if (res.code !== 200) {
        return this.$message.error('订单发货失败！')
      }
      this.$message.success('订单发货成功！')
      this.getOrderList()
    },
    // 批量完成订单
    async completeOrder () {
      if (this.multipleSelection == null || this.multipleSelection.length == 0) {
        return this.$message.info('请先勾选订单！')
      }
      const confirmResult = await this.$confirm(
        '将所有已选中的已发货订单，其余订单完成无效, 是否继续?',
        '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }
      ).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('取消操作！')
      }
      const { data: res } = await this.$http.post('admin/order/changeOrdersStatus', {
        data: this.multipleSelection,
        type: 3,
      })
      if (res.code !== 200) {
        return this.$message.error('订单已完成操作失败！')
      }
      this.$message.success('订单已完成操作成功！')
      this.getOrderList()
    },

    // 批量取消订单
    // async cancelOrder () {
    //   if (this.multipleSelection == null || this.multipleSelection.length == 0) {
    //     return this.$message.info('请先勾选订单！')
    //   }
    //   const confirmResult = await this.$confirm(
    //     '只能取消待支付和待确认的订单，其余订单取消无效, 是否继续?',
    //     '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }
    //   ).catch(err => err)
    //   if (confirmResult !== 'confirm') {
    //     return this.$message.info('取消操作！')
    //   }
    //   const { data: res } = await this.$http.post('admin/order/changeOrdersStatus', {
    //     data: this.multipleSelection,
    //     type: 6,
    //   })
    //   if (res.code !== 200) {
    //     return this.$message.error('订单取消操作失败！')
    //   }
    //   this.$message.success('订单取消操作成功！')
    //   this.getOrderList()
    // },

    async getOrderList () {
      const { data: res } = await this.$http.get('admin/order/getDwOrderList', {
        params: this.queryInfo
      })
      if (res.code !== 200) {
        return this.$message.error('暂无订单信息！')
      }
      console.log(res)
      this.total = res.result.count
      this.orderlist = res.result.list
      if (window.sessionStorage.getItem('pathCanLook') == 2) { //仅查看
        this.canLook = 2
      }
    },

    exportOrder (order_id) {
      localStorage.setItem("kuncun_order_id", order_id);
    },

    handleSizeChange (newSize) {
      this.queryInfo.pagesize = newSize
      this.getOrderList()
    },

    handleCurrentChange (newPage) {
      this.queryInfo.pagenum = newPage
      this.getOrderList()
    },

    // 展示修改地址的对话框
    showBox () {
      this.addressVisible = true
    },

    addressDialogClosed () {
      this.$refs.addressFormRef.resetFields()
    }
  }
}
</script>

<style lang="less" scoped>
.el-cascader {
  width: 100%;
}
.el-table .cell {
  white-space: pre-line;
}
.el-row {
  margin-top: 10px;
}

.daiqueren {
  background-color: aquamarine;
}

.daifahuo {
  background-color: rgb(242, 255, 127);
}
.yifahuo {
  background-color: rgb(8, 27, 133);
}
.aaaa {
  margin-left: 10px;
}
</style>
